import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { HeaderComponent } from '../components/header/header.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { SubheaderComponent } from '../components/subheader/subheader.component';

@Component({
  selector: 'app-additional-data',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    ButtonModule,
    SidebarComponent,
    HeaderComponent,
    SubheaderComponent
  ],
  templateUrl: './additional-data.component.html',
  styleUrl: './additional-data.component.css'
})
export class AdditionalDataComponent implements OnInit {
  additionalDataForm!: FormGroup;

  constructor(
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  yesNoOptions = [
    { label: 'Seleccionar...', value: null, disabled: true },
    { label: 'Sí', value: 'yes' },
    { label: 'No', value: 'no' }
  ];

  private initializeForm(): void {
    this.additionalDataForm = this.fb.group({
      lawfulUse: [null, [Validators.required]],
      ownBehalf: [null, [Validators.required]],
      thirdPartyResources: [null, [Validators.required]],
      pep: [null, [Validators.required]]
    });
  }

  // Métodos para obtener controles del formulario
  get lawfulUse() { return this.additionalDataForm.get('lawfulUse'); }
  get ownBehalf() { return this.additionalDataForm.get('ownBehalf'); }
  get thirdPartyResources() { return this.additionalDataForm.get('thirdPartyResources'); }
  get pep() { return this.additionalDataForm.get('pep'); }

  // Método para obtener mensajes de error
  getErrorMessage(fieldName: string): string {
    const field = this.additionalDataForm.get(fieldName);
    if (field?.errors && field.touched) {
      if (field.errors['required']) {
        return 'Debe seleccionar una opción';
      }
    }
    return '';
  }

  goBack(): void {
    this.router.navigate(['/second-reference']);
  }

  onSubmit(): void {
    if (this.additionalDataForm.valid) {
      const formData = this.additionalDataForm.value;
      console.log('Datos adicionales:', formData);
      this.router.navigate(['/verify-identity']);
    } else {
      // Marcar todos los campos como tocados para mostrar errores
      Object.keys(this.additionalDataForm.controls).forEach(key => {
        this.additionalDataForm.get(key)?.markAsTouched();
      });
    }
  }
}
